const items = [
  "BULK LIQUID STORAGE",
  "BULK LIQUID HANDLING",
  "TRANSPORTATION",
  "COMMODITY TRADING",
  "MOLASSES",
  "PROBOLINGGO — EAST JAVA",
];

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="overflow-hidden border-y border-ujn-accent/25 bg-ujn-deeper py-5"
  >
    <div className="ujn-marquee-track flex w-max items-center">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {items.map((item) => (
            <span key={`${dup}-${item}`} className="flex items-center">
              <span className="px-8 font-mono text-[11px] tracking-[0.3em] text-ujn-offwhite/55 sm:text-xs">
                {item}
              </span>
              <span className="h-1 w-1 bg-ujn-subtle" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
